// extracted by mini-css-extract-plugin
export default {"logViewerWidget":"app-react-components-LogViewer-LogViewer-module__log-viewer-widget"};